// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// finds the highest throughput of all enabled modulations and
// returns that modulation
const getGreatestEnabledThroughput = (modulations, changedModId) => (
  modulations.reduce((a, d) => (
    // if this modulation is enabled
    d.enabled &&
    // and its id doesn't match the modulation we're changing
    d.radioModulationId !== changedModId &&
    // and a is null or
    // d's throughput is greater than the stored one
    (a === null || d.throughput >= a.throughput)
      ? d
      : a
  ), null)
)

export default getGreatestEnabledThroughput
